import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
import './class-component-hooks'
import { runSeamlessAuth } from '@/api/auth/seamlessAuth'

/* Bootstrap */
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)
/* Fonts Awesome */
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { dom } from '@fortawesome/fontawesome-svg-core'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

library.add(fas, far)
dom.watch()

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-cropper', VueCropper)

/* Sentry */
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

if (process.env.VUE_APP_SENTRY_ENV !== 'dev') {
  Sentry.init({
    Vue,
    dsn: 'https://e79ce4f212f540259461d267b7576bc4@digital-sentry.ddns.net/15',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'digital.etu.ru', /^\//]
      })
    ],
    ignoreErrors: [
      'ChunkLoadError',
      '{no status}',
      'Navigation cancelled from',
      'Cannot redefine property: googletag',
      'Redirected when going from',
      'Avoided redundant navigation',
      '[IGNORE]'
    ],
    normalizeDepth: 4,
    release: process.env.VUE_APP_RELEASE,
    environment: process.env.VUE_APP_SENTRY_ENV,
    tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACE_RATE)
  })
}

/* Custom Field */
import { Components, VueFormGeneratorFields } from '@it/orpk-vue-ui'

import AgGridField from '@/components/generatorFields/AgGrid.vue'
import BootstrapCheckbox from '@/components/generatorFields/BootstrapCheckbox.vue'

import ModalOpenInput from './components/routes/ctt/rid/components/ModalOpenInput.vue'

Vue.component('MainCard', Components.MainCard)
Vue.component('InfoModal', Components.InfoModal)
Vue.component('WarningModal', Components.WarningModal)
Vue.component('ClassicCKEditor', Components.ClassicCKEditor)
Vue.component('DevServerModal', Components.DevServerModal)
Vue.component('LoadingBottomCard', Components.LoadingBottomCard)
Vue.component('CookiesUsage', Components.CookiesUsage)
Vue.component('NotificationChangelog', Components.NotificationChangelog)
Vue.component('Changelog', Components.Changelog)

Vue.component('fieldCKEditor', VueFormGeneratorFields.CKEditor5Field)
Vue.component('fieldAgGrid', AgGridField)
Vue.component('fieldBootstrap', VueFormGeneratorFields.BootstrapInput)
Vue.component('fieldBootstrapCheckbox', BootstrapCheckbox)
Vue.component(
  'fieldBootstrapCheckboxGroup',
  VueFormGeneratorFields.BootstrapCheckboxGroup
)
Vue.component(
  'fieldBootstrapDatepicker',
  VueFormGeneratorFields.BootstrapDatepicker
)
Vue.component('fieldDatepicker', VueFormGeneratorFields.DatepickerField)
Vue.component(
  'fieldBootstrapRadioGroup',
  VueFormGeneratorFields.BootstrapRadioGroup
)
Vue.component('fieldBootstrapSelect', VueFormGeneratorFields.BootstrapSelect)
Vue.component(
  'fieldBootstrapTextArea',
  VueFormGeneratorFields.BootstrapTextArea
)
Vue.component('fieldDatepicker', VueFormGeneratorFields.DatepickerField)
Vue.component('fieldMultiselect', VueFormGeneratorFields.MultiselectField)
Vue.component('fieldHeaderSeparator', VueFormGeneratorFields.HeaderSeparator)
Vue.component('fieldModalOpenInput', ModalOpenInput)

/* Form Generator */
import VueFormGenerator from '@it/vue-form-generator'
Vue.use(VueFormGenerator)

Vue.config.ignoredElements = ['etu-nav-button']
Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
  Vue.config.silent = true
}

store.dispatch('user/fetchCurrentUser', true).then(async () => {
  const isRedirecting = await runSeamlessAuth(
    store.getters['user/isAuthenticated']
  )
  if (isRedirecting) {
    return
  }

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
